<template>
    <a-card class="supsis-plan">
        <div class="editable-form" v-if="editableCard">
            <div class="form-button" @click="editPlan">
                <span class="material-icons"> edit </span>
            </div>
            <div @click="deletePlan" class="form-button delete-button">
                <span class="material-icons"> delete </span>
            </div>
        </div>
        <div class="p-card-header">
            <div>
                <div class="subtitle top" :class="{ setFont: plan.isPopular }">
                    {{ plan.title }}
                </div>
                <div class="title">{{ plan.altTitle }}</div>
                <div class="subtitle price setFontPrice">
                    <div>{{ getPrice(plan) }}₺</div>
                    <div>
                        <div class="discount" v-if="getDiscount(plan) > getPrice(plan)">{{ getDiscount(plan) }}₺</div>
                        <div class="oldprice" v-if="getDiscount(plan) < getPrice(plan) && getPrice(plan) > plan.price">
                            {{
                                plan.type == "supsis"
                                    ? `${details.agentCount}x`
                                    : ["whatsapp", "whatsapp-business"].includes(plan.type)
                                    ? `${details.whatsappChannel}x`
                                    : ""
                            }}{{ plan.price }}₺
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div
                    class="popular"
                    v-if="plan.isPopular && !isActive(plan, currentPlans[plan.dynamicType || plan.type])"
                >
                    Popüler
                </div>
                <div
                    class="popular"
                    v-if="
                        wizard
                            ? isSelected
                            : !editableCard && isActive(plan, currentPlans[plan.dynamicType || plan.type])
                    "
                >
                    Mevcut Plan
                </div>
                <div class="popular" v-if="plan.isTrialPlan">Deneme Paketi</div>
                <div class="popular" v-if="editableCard">{{ plan.siteId ? "Özel Plan" : "Genel Plan" }}</div>
            </div>
        </div>

        <div class="p-card-content">
            <div v-if="plan.features">
                <template v-for="feature of plan.features">
                    <p
                        v-for="key of Object.keys(feature)
                            .filter((key) => (typeof feature[key] == 'number' ? feature[key] !== 0 : true))
                            .filter((key) => feature[key] !== false)
                            .filter((key) => key !== 'type')"
                        :key="key"
                    >
                        <i class="fa fa-check" />
                        <template v-if="key == 'freeAgentCount'"> {{ feature[key] }} Ücretsiz Temsilci</template>
                        <template v-else-if="key == 'agentCount'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }} Temsilci
                        </template>
                        <template v-else-if="key == 'maxSessionCount'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }}
                            Chatbot
                        </template>
                        <template v-else-if="key == 'integrationCount'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }} Chatbot Entegrasyon
                        </template>
                        <template v-else-if="key == 'storyCountLimit'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }} Chatbot Hikaye
                        </template>
                        <template v-else-if="key == 'versionHistoryCount'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }} Chatbot Sürüm Geçmişi
                        </template>
                        <template v-else-if="key == 'activeChatbotLimit'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }} Aktif Chatbot
                        </template>
                        <template v-else-if="key == 'autoTranslation'"> Otomatik Çeviri </template>
                        <template v-else-if="key == 'voiceCalling'">Sesli Arama</template>
                        <template v-else-if="key == 'videoCalling'">Görüntülü Arama</template>
                        <template v-else-if="key == 'dataProtect'"> Veri Güvenliği </template>
                        <template v-else-if="key == 'accessAllAgent'"> Tüm Temsilciler için Erişim </template>
                        <template v-else-if="key == 'notAdditionalPrice'"> Ek Maliyet Gerektirmez </template>

                        <template v-else-if="key == 'report'">
                            {{ feature[key] == "basic-report" ? "Normal Raporlama" : "Detaylı Raporlama" }}
                        </template>
                        <template v-else-if="key == 'visitorTracking'">Anlık Ziyaretci Takibi</template>
                        <template v-else-if="key == 'fileAndVoiceMessage'">Dosya ve Ses Kaydı Paylaşımı</template>
                        <template v-else-if="key == 'teamChatEntegration'">Takım Konuşması Entegrasyonu</template>
                        <template v-else-if="key == 'support'">
                            {{ feature[key] == "basic-support" ? "Destek" : "7/24 Destek" }}
                        </template>
                        <template v-else-if="key == 'softwareSupport'">Yazılım Desteği</template>
                        <template v-else-if="key == 'dedicatedCustomerSupport'">Özel Müşteri Desteği</template>
                        <template v-else-if="key == 'chatAndNotification'">Chat ve Bildirimler</template>
                        <template v-else-if="key == 'chatballonCustomization'">Sohbet Balonu Özeleştirme</template>
                        <template v-else-if="key == 'removeSupsisLogo'"> Supsis Logo Kaldırma</template>
                        <template v-else-if="key == 'databaseConnection'">İzole Veritabanı Bağlantısı</template>
                        <template v-else-if="key == 'singlePanelAccess'">Tek Panelden Yönetim</template>
                        <template v-else-if="key == 'ticketSystem'">Ticket Sistemi</template>
                        <template v-else-if="key == 'whatsappEntegration'">Whatsapp Entegrasyonu</template>
                        <template v-else-if="key == 'instagramEntegration'">Instagram Entegrasyonu</template>
                        <template v-else-if="key == 'messengerEntegration'">Messenger Entegrasyonu</template>
                        <template v-else-if="key == 'telegramEntegration'">Telegram Entegrasyonu</template>
                        <template v-else-if="key == 'maxTriggerCount'">
                            {{ feature[key] < 0 ? "Sınırsız" : feature[key] }}
                            Akıllı Tetikleyici
                        </template>
                        <template v-else-if="key == 'brodcastPerMessage'">
                            {{ feature[key] < 0 ? "Mesaj Başına Ek Ücret" : `${feature[key]}₺ Toplu Mesaj Başına` }}
                        </template>
                        <template v-else-if="key == 'bulkMessageSending'">Toplu Mesaj Gönderme</template>
                        <template v-else-if="key == 'messageUnregisteredNumbers'">
                            Kayıtlı Olmayan Numaralara Mesajlaşma
                        </template>
                        <template v-else-if="key == 'personalizedBroadcastMessage'">
                            Kişiselleştirilmiş Yayın Mesajı
                        </template>
                        <template v-else-if="key == 'chatbotButtonActivity'">Otomatik Düğme / Chatbot</template>
                        <template v-else-if="key == 'chatbotEntergration'">Chatbot Entegrasyonu</template>
                        <template v-else-if="key == 'controlWhatsapp'">Whatsapp Yönetimi</template>
                        <template v-else-if="key == 'visitorStartChat'">Ziyaretci Chat Başlatma</template>
                        <template v-else-if="key == 'editableChatbotMessage'">
                            Kişileştirilmiş Asistan / Chatbot Mesaj
                        </template>
                        <template v-else-if="key == 'mailEntegration'">Mail Entegrasyonu</template>
                        <template v-else-if="key == 'smsEntegration'">SMS Entegrasyonu</template>
                        <template v-else-if="key == 'chatArchiveTime'">
                            {{ feature[key] < 0 ? "Sınırsız" : `${feature[key] / 7} Hafta`}}  Arşiv
                        </template>
                        <template v-else-if="key == 'readyContents'"> Hazır İçerikler </template>
                        <template v-else-if="key == 'allEntegrations'"> Entegrasyonlar </template>
                    </p>
                </template>
            </div>
        </div>
        <button
            v-if="!editableCard"
            class="btn"
            :class="{
                passive: wizard
                    ? isSelected
                    : isUpgrade(plan) || isActive(plan, currentPlans[plan.dynamicType || plan.type]),
            }"
            :disabled="wizard ? isSelected : isUpgrade(plan)"
            @click="
                wizard
                    ? subscribe(plan)
                    : isActive(plan, currentPlans[plan.dynamicType || plan.type]) &&
                      currentPlans[plan.dynamicType || plan.type].plan.enabled
                    ? unsubscribe(plan)
                    : isActive(plan, currentPlans[plan.dynamicType || plan.type]) &&
                      !currentPlans[plan.dynamicType || plan.type].plan.enabled
                    ? subscribe(plan)
                    : subscribe(plan)
            "
        >
            {{
                wizard
                    ? isSelected
                        ? "Aktif Plan"
                        : "Plan Seç"
                    : isUpgrade(plan)
                    ? "Geçiş Yapılamaz"
                    : isActive(plan, currentPlans[plan.dynamicType || plan.type]) &&
                      currentPlans[plan.dynamicType || plan.type].plan.enabled
                    ? "İptal Et"
                    : isActive(plan, currentPlans[plan.dynamicType || plan.type]) &&
                      !currentPlans[plan.dynamicType || plan.type].plan.enabled
                    ? "Devam Et"
                    : "Plan Seç"
            }}
        </button>
    </a-card>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../utils/log2";
import _ from "lodash";

const log = log2("Card");
export default {
    name: "Card",
    props: {
        plan: {
            type: Object,
            default: {},
        },
        period: {
            type: String,
            required: false,
            default: "monthly",
        },
        details: {
            type: Object,
            default: () => ({
                agentCount: 1,
                whatsappChannel: 1,
            }),
        },
        editableCard: {
            type: Boolean,
            default: false,
        },
        wizard: {
            type: Boolean,
            default: false,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            site: (state) => state.site.site,
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) => state.site.plans,
        }),
    },
    data() {
        return {
            currentPlan: {},
        };
    },
    mounted() {
        this.currentPlan = (this.plans || []).find(
            (plan) => plan._id == this.currentPlans[this.plan.dynamicType || this.plan.type]?.plan?.planId
        );
    },
    methods: {
        subscribe(plan) {
            let payload = { planId: plan._id, period: this.period };
            if (plan.type == "supsis") {
                payload.details = {
                    agentCount: plan.isFreePlan ? 1 : this.details.agentCount,
                };
            } else if (plan.type == "whatsapp" || plan.type == "whatsapp-business") {
                payload.details = {
                    whatsappChannel: this.details.whatsappChannel,
                };
            }
            this.$emit("subscribe", payload);
        },
        unsubscribe(plan) {
            this.$emit("unsubscribe", {
                planId: plan._id,
                planType: plan.dynamicType || plan.type,
            });
        },
        isUpgrade(plan) {
            const currentPlanAction = this.currentPlans[plan.dynamicType || plan.type]?.plan;
            return (
                currentPlanAction &&
                ((currentPlanAction.period == "annual" && this.period == "monthly") ||
                    (currentPlanAction.period == "annual" && this.currentPlan.price > plan.price))
            );
        },
        upgradePlan(plan, currentPlan) {
            return (
                currentPlan.plan.planId == plan._id &&
                currentPlan.plan.period !== this.period &&
                (plan.type !== "supsis" || currentPlan.plan.details.agentCount !== this.details.agentCount) &&
                (plan.type !== "whatsapp" ||
                    currentPlan.plan.details.whatsappChannel !== this.details.whatsappChannel) &&
                (plan.type !== "whatsapp-business" ||
                    currentPlan.plan.details.whatsappChannel !== this.details.whatsappChannel)
            );
        },
        isActive(plan, currentPlan) {
            return (
                currentPlan &&
                currentPlan.plan.period == this.period &&
                currentPlan.plan.planId == plan._id &&
                (plan.type !== "supsis" || currentPlan.plan.details.agentCount == this.details.agentCount) &&
                (plan.type !== "whatsapp" ||
                    currentPlan.plan.details.whatsappChannel == this.details.whatsappChannel) &&
                (plan.type !== "whatsapp-business" ||
                    currentPlan.plan.details.whatsappChannel == this.details.whatsappChannel)
            );
        },
        getPrice(value) {
            let price = value.price - (value.price * value.couponDiscount || 0) / 100;

            if (this.plan.type == "supsis") {
                price =
                    this.period == "monthly"
                        ? price * this.details.agentCount
                        : (price * this.details.agentCount * 12 * (100 - value.yearlyDiscount)) / 100;
            } else if (this.plan.type == "whatsapp" || this.plan.type == "whatsapp-business") {
                price =
                    this.period == "monthly"
                        ? price * this.details.whatsappChannel
                        : (price * this.details.whatsappChannel * 12 * (100 - value.yearlyDiscount)) / 100;
            } else {
                price = this.period == "monthly" ? price : (price * 12 * (100 - value.yearlyDiscount)) / 100;
            }
            return ~~price;
        },
        getDiscount(value) {
            let price = value.price;
            if (this.plan.type == "supsis") {
                price =
                    this.period == "monthly" ? this.details.agentCount * price : price * this.details.agentCount * 12;
            } else if (this.plan.type == "whatsapp" || this.plan.type == "whatsapp-business") {
                price =
                    this.period == "monthly"
                        ? this.details.whatsappChannel * price
                        : price * this.details.whatsappChannel * 12;
            } else {
                price = this.period == "monthly" ? price : price * 12;
            }
            return ~~price;
        },
        editPlan() {
            this.$emit("edit-action", this.plan);
        },
        deletePlan() {
            this.$emit("delete-action", this.plan);
        },
    },
    watch: {
        plans: {
            handler(newVal) {
                this.currentPlan = newVal.find(
                    (plan) => plan._id == this.currentPlans[this.plan.dynamicType || this.plan.type]?.plan?.planId
                );
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
$base-color: #ec4b1d;
$text-color: #171725;
.ant-card {
    border-radius: 20px;
}

.supsis-plan {
    width: 270px;
    margin-right: 5px;
    margin-top: 5px;
    position: relative;

    :first-child {
        margin-top: 0;
    }

    :last-child {
        margin-right: 0;
    }

    .editable-form {
        position: absolute;
        top: 10px;
        right: -18px;

        .form-button {
            font-size: 12px;
            border-radius: 100px;
            background: #ec4b1d;
            color: white;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .delete-button {
            margin-top: 4px;
        }
    }

    .ant-card-body {
        .p-card-header {
            border-bottom: 1px solid #f1f1f5;
            display: flex;
            justify-content: space-between;

            .popular {
                color: #ffffff;
                background-color: $base-color;
                font-size: 12px;
                padding: 5px 8px;
                border-radius: 5px;
                float: right;
                font-family: Poppins;
                font-weight: 600;
                margin-top: 4px;
            }
        }

        .subtitle {
            font-family: Poppins;
            font-weight: 600;
            font-size: 22px;
            color: $text-color;

            &.top {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            &.setFont {
                font-size: 15px;
            }

            &.price {
                color: $text-color;
                font-size: 36px;
                margin-bottom: 0.5em;
                display: flex;
                align-items: baseline;
                &.setFontPrice {
                    font-size: 30px !important;
                }
                .discount {
                    text-decoration-line: line-through;
                    font-weight: 500;
                    font-size: 16px;
                    color: $base-color;
                    margin-left: 6px;
                }
                .oldprice {
                    font-weight: 500;
                    font-size: 16px;
                    color: $base-color;
                    margin-left: 6px;
                }
            }
        }

        .title {
            font-family: Roboto;
            font-weight: 700;
            font-size: 24px;
            color: $base-color;
        }

        .p-card-content {
            height: 300px;
            overflow-y: scroll;

            i {
                color: $base-color;
                padding-right: 5px;
            }

            p {
                font-size: 13px;
                margin-bottom: 1em;
                color: $text-color;

                &:first-child {
                    margin-top: 1em;
                }
            }

            &:-webkit-scrollbar {
                display: none;
            }

            &::-webkit-scrollbar-thumb {
                background: $base-color;
            }
        }

        button {
            margin-top: 10px;
            width: 100%;
            border-radius: 10px;
            background-color: $base-color;
            color: #ffffff;
            font-size: 14px;

            &.passive {
                background-color: #ffffff;
                color: #696974;
                border: 1px solid #e2e2ea;
                cursor: not-allowed;
            }
        }
    }
}
</style>
